import { AppRootStateType } from 'state/store';

export const articlesSelect = (state: AppRootStateType) => state.articles.articles;
export const articleSelect = (state: AppRootStateType) => state.articles.article;
